export const defaultActivityTemplate = (baseDate: Date = new Date()) => `{
  "activityName": "Linehaul Pickup Activity",
  "processReference": "PROC-2026-0001",
  "sequenceNumber": 1,
  "isStartingService": true,
  "isEndingService": false,
  "activityType": "TRANSPORT",
  "activitySubtype": "ROAD_TRANSPORT",
  "executionStatus": "PLANNED",
  "relatedObject": "urn:bol:service:sample-service",
  "contacts": [
    {
      "role": "REQUESTOR",
      "persons": [
        {
          "givenName": "Emma",
          "familyName": "Martin",
          "email": "emma.martin@example.com",
          "telephone": "+33102030405"
        }
      ]
    }
  ],
  "startLocation": {
    "location": {
      "address": {
        "addressLocality": "Lille",
        "postalCode": "59000",
        "addressCountry": {
          "countryCode": "FR",
          "countryName": "France"
        }
      }
    },
    "plannedStartTimeRange": {
      "earliestDateTime": "${baseDate.toISOString()}",
      "latestDateTime": "${new Date(baseDate.getTime() + 2 * 60 * 60 * 1000).toISOString()}"
    }
  },
  "endLocation": {
    "location": {
      "address": {
        "addressLocality": "Paris",
        "postalCode": "75012",
        "addressCountry": {
          "countryCode": "FR",
          "countryName": "France"
        }
      }
    },
    "plannedEndTimeRange": {
      "earliestDateTime": "${new Date(baseDate.getTime() + 6 * 60 * 60 * 1000).toISOString()}",
      "latestDateTime": "${new Date(baseDate.getTime() + 8 * 60 * 60 * 1000).toISOString()}"
    }
  },
  "serviceRequests": [
    {
      "uri": "urn:bol:service-request:sr-001"
    }
  ],
  "externalReferences": [
    {
      "externalReferenceType": "CUSTOMER_ID",
      "reference": "ACT-REF-2026-001"
    }
  ]
}`;
